import React from 'react'
import { useFela } from 'react-fela'
import ds from 'views/styles/designSystem'
import { SpinnerProps } from './Spinner'

// Use as default value for <Spin /> antd component, dont import it
const Loader: React.FC<SpinnerProps> = ({ height, width, variant }) => {
  const { css } = useFela()
  return (
    <div className={css(rules.loaderIcon)}>
      <svg width={width} height={height} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        {variant === 'gradient' && (
          <defs>
            <linearGradient id="gradient">
              <stop offset="5%" stopColor={ds.brand('gradientStart')} />
              <stop offset="95%" stopColor={ds.brand('gradientStop')} />
            </linearGradient>
          </defs>
        )}
        <path
          fill={variant === 'white' ? ds.brand('white') : 'url(#gradient)'}
          d="M19.167 9.167c.458 0 .833.375.833.833a.836.836 0 0 1-.833.833H15a.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833h4.167zM5.833 10a.836.836 0 0 1-.833.833H.833A.836.836 0 0 1 0 10c0-.458.375-.833.833-.833H5c.458 0 .833.375.833.833zM10 14.167c.458 0 .833.375.833.833v4.167A.836.836 0 0 1 10 20a.836.836 0 0 1-.833-.833V15c0-.458.375-.833.833-.833zM10 0c.458 0 .833.375.833.833V5a.836.836 0 0 1-.833.833A.836.836 0 0 1 9.167 5V.833C9.167.375 9.542 0 10 0zm3.61 7.917a.836.836 0 0 1 .307-1.141l3.609-2.083a.835.835 0 1 1 .833 1.448L14.75 8.224a.835.835 0 0 1-1.14-.307zm-7.22 4.166a.836.836 0 0 1-.307 1.141l-3.609 2.083a.835.835 0 1 1-.833-1.448l3.609-2.083a.835.835 0 0 1 1.14.307zm6.834 1.828l2.083 3.61a.835.835 0 1 1-1.448.833l-2.083-3.61a.835.835 0 1 1 1.448-.833zM6.141 1.646l2.083 3.61a.835.835 0 1 1-1.448.833l-2.083-3.61a.835.835 0 1 1 1.448-.833zm5.942 4.745a.835.835 0 0 1-.307-1.141l2.083-3.61a.836.836 0 0 1 1.448.834l-2.083 3.61a.836.836 0 0 1-1.14.307zm-4.166 7.218c.4.23.536.74.307 1.141l-2.083 3.61a.836.836 0 0 1-1.448-.834l2.083-3.61a.836.836 0 0 1 1.14-.307zm10.437.25a.836.836 0 0 1-.833 1.448l-3.61-2.083a.836.836 0 0 1 .834-1.448l3.61 2.083zM1.646 6.141a.836.836 0 0 1 .833-1.448l3.61 2.083a.836.836 0 0 1-.833 1.448l-3.61-2.083z"
          fillRule="nonzero"
        />
      </svg>
    </div>
  )
}

const rules = {
  loaderIcon: () => ({
    '> svg': {
      animation: 'glnk__loader 7500ms linear infinite',
    },
  }),
}

export default Loader
